// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./common/fonts/NunitoSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./common/fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html body {
  margin: 0;
  font-family: "NunitoSans-Regular", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html body .row {
  margin: 0;
}
html body ul {
  list-style: none;
  padding: 0;
}
html body ul li {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

h1,
h2,
h3,
h4,
h5,
h6,
.poppinsFont {
  font-family: "Poppins-Medium", sans-serif;
}

.nunitoFont {
  font-family: "NunitoSans-Regular", Arial, Helvetica, sans-serif;
}

@font-face {
  font-family: "NunitoSans-Regular";
  src: local("NunitoSans-Regular"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 400;
}
@font-face {
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 500;
  src: local("Poppins"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,+DAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,kCAAA;AACF;AAAE;EACE,SAAA;AAEJ;AAAE;EACE,gBAAA;EACA,UAAA;AAEJ;AADI;EACE,qBAAA;EACA,SAAA;EACA,UAAA;AAGN;;AAEA;EACE,+EAAA;AACF;;AAEA;;;;;;;EAOE,yCAAA;AACF;;AAEA;EACE,+DAAA;AACF;;AAEA;EACE,iCAAA;EACA,4FAAA;EAEA,gBAAA;AAAF;AAGA;EACE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iFAAA;AADF","sourcesContent":["html body {\n  margin: 0;\n  font-family: 'NunitoSans-Regular', Arial, Helvetica, sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  .row {\n    margin: 0;\n  }\n  ul {\n    list-style: none;\n    padding: 0;\n    li {\n      list-style-type: none;\n      margin: 0;\n      padding: 0;\n    }\n  }\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.poppinsFont {\n  font-family: 'Poppins-Medium', sans-serif;\n}\n\n.nunitoFont {\n  font-family: 'NunitoSans-Regular', Arial, Helvetica, sans-serif;\n}\n\n@font-face {\n  font-family: 'NunitoSans-Regular';\n  src: local('NunitoSans-Regular'),\n    url('./common/fonts/NunitoSans-Regular.ttf') format('truetype');\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: 'Poppins-Medium';\n  font-style: normal;\n  font-weight: 500;\n  src: local('Poppins'),\n    url('./common/fonts/Poppins-Medium.ttf') format('truetype');\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
